<h3 *ngIf="process.isProcess" class="md-subhead">Statistic:</h3>
<div class="mat-typography content">
    <app-process-status-row [process]="process"></app-process-status-row>
    <app-process-statistic-section [process]="process"></app-process-statistic-section>
</div>

<app-process-stats-by-status-section [process]="process"></app-process-stats-by-status-section>
<app-data-source-category-view [dataSourceCategories]="process.dataSourceCategories">
</app-data-source-category-view>